import { Fragment, useContext, useMemo } from 'react';
import image from 'assets/img/image/bg.png';
import Cloud from 'assets/img/image/cloud-layout.png';
import { LanguageContext } from 'contexts/Languages';
import { termsEn, termsTr } from './text';
import {
  Container,
  HeaderArea,
  BackImage,
  HeaderContent,
  HeaderTitle,
  ContextContainer,
  Context,
  Text,
  Line,
  CloudImg
} from './style';

const Terms = () => {
  const { language } = useContext(LanguageContext);

  const termsText = useMemo(() => {
    switch (language.code) {
      case 'en':
        return termsEn;
      case 'tr':
        return termsTr;
      default:
        return termsEn;
    }
  }, [language])

  return (
    <Fragment>
      <CloudImg
        src={Cloud}
        alt='cloud'
        width={'100%'}
        height={'100%'}
      />
      <Container>
        <HeaderArea>
          <BackImage
            src={image}
            alt='Background'
            width={'100%'}
            height={'100%'}
          />
          <HeaderContent>
            <HeaderTitle>Terms & Conditions</HeaderTitle>
          </HeaderContent>
        </HeaderArea>

        <ContextContainer>
          <Context>
            <Text>
              {termsText}
            </Text>
          </Context>
        </ContextContainer>
      </Container>
      <Line />
    </Fragment>
  )
};

export default Terms;
